import {NgModule} from '@angular/core';
import {UploaderComponent} from './uploader/uploader.component';
import {ImgBoxComponent} from './img-box/img-box.component';
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [UploaderComponent, ImgBoxComponent],
  imports: [
    CommonModule
  ],
  exports: [UploaderComponent, ImgBoxComponent]
})
export class UiKitsModule {}
